import { useState } from 'react';
import clientService from '../../api/clientService';
import { useNotifications } from '../../context/NotificationContext';
import StarRating from '../common/StarRating';

/** Modal for leaving a review on a completed booking. */
export default function ReviewModal({ booking, onClose, onDone }) {
  const notify = useNotifications();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await clientService.createReview({ bookingId: booking.id, rating, comment });
      notify.success('Thanks for your review');
      onDone();
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box card pad" onClick={(e) => e.stopPropagation()}>
        <div className="spread" style={{ marginBottom: '.75rem' }}>
          <h3>Review {booking.technicianName}</h3>
          <button onClick={onClose}><i className="bi bi-x-lg" /></button>
        </div>
        <form onSubmit={submit}>
          <div className="field">
            <label>Rating</label>
            <StarRating value={rating} onRate={setRating} />
          </div>
          <div className="field">
            <label>Comment (optional)</label>
            <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={2000} />
          </div>
          <button className="btn accent block" disabled={busy}>{busy ? 'Submitting…' : 'Submit review'}</button>
        </form>
      </div>
    </div>
  );
}
